module.exports = __webpack_public_path__ + "2823d39e9e78ef40269b82b6d2fd9be4.png";